export default "__VITE_ASSET__CpTCDpqf__"